export { default } from './PageCulturalOrganization.vue'
